$.fn.serializeObject = function()
{
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

function autoValidateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


function autoValidateDMY(param,value) {
    var date = value.split(param);
    var d = parseInt(date[0], 10),
        m = parseInt(date[1], 10),
        y = parseInt(date[2], 10);
    var res = new Date(y, m - 1, d);
    if(res=="Invalid Date"){
        return false;
    }else{
        return true;
    }
}

function autoValidateYMD(param,value) {
    var date = value.split(param);
    var d = parseInt(date[0], 10),
        m = parseInt(date[1], 10),
        y = parseInt(date[2], 10);
    var res = new Date(y, m - 1, d);
    if(res=="Invalid Date"){
        return false;
    }else{
        return true;
    }
}

function comprobarBloqueFormulario(cont_id){
    $('.form_'+cont_id).addClass('was-validated');
    $('.form_'+cont_id+' .msgOK,.form_'+cont_id+' .msgKO').hide();
    $('.form_'+cont_id+' .has-error').removeClass("has-error");
    var resultado = true;
    var labels = [];
    $('.form_'+cont_id+' span.errorText').html("");
    $('.form_'+cont_id+' .alertR').hide();
    $('.form_'+cont_id+' input.obli,.form_'+cont_id+' textarea.obli').each(function(){
        if($(this).is(":visible")){
            var valor = $(this).val();
            if(valor.trim()==""){
                resultado = false;
                $(this).closest(".form-group").addClass("has-error");
                labels.push($(this).closest(".form-group").find(".control-label").text()+" "+$('.form_'+cont_id).attr("texto-obligatorio"));
                $(this).closest(".form-group").find(".errorText").text($('.form_'+cont_id).attr("texto-obligatorio"));
                //console.log($(this).attr('name'));
            }
        }
    })
    $('.form_'+cont_id+' select.obli').each(function(){
        if($(this).is(":visible") || $('#'+$(this).attr("id")+"-button").is(":visible") || $('#'+$(this).attr("id")+"SelectBoxItContainer").is(":visible")){
            var valor = $(this).val();
            if(valor.trim()==""){
                resultado = false;
                $(this).closest(".form-group").addClass("has-error");
                labels.push($(this).closest(".form-group").find(".control-label").text()+" "+$('.form_'+cont_id).attr("texto-obligatorio"));
                $(this).closest(".form-group").find(".errorText").text($('.form_'+cont_id).attr("texto-obligatorio"));
                //console.log($(this).attr('name'));
            }
        }
    })
    if($('.form_'+cont_id+' .obliCheck').length>0){
        var selected = [];
        if($(this).is(":visible")){
            $('.form_'+cont_id+' .obliCheck').each(function() {
                var seleccionado = $(this).is(":checked");
                if(seleccionado==0){
                    resultado = false;
                    $(this).closest(".form-group").addClass("has-error");
                    labels.push($(this).closest(".form-group").find(".control-label").text()+" "+$('.form_'+cont_id).attr("texto-obligatorio"));
                    $(this).closest(".form-group").find(".errorText").text($('.form_'+cont_id).attr("texto-obligatorio"));
                //console.log($(this).attr('name'));
            }
            });
        }
    }
    $('.form_'+cont_id+' .obliCheckOne').each(function(){
        if($(this).is(":visible") ){
            var seleccionado = $(this).is(":checked");
            if(seleccionado==0){
                resultado = false;
                $(this).closest(".form-group").addClass("has-error");
                labels.push($(this).closest(".form-group").find(".control-label").text()+" "+$('.form_'+cont_id).attr("texto-obligatorio"));
                $(this).closest(".form-group").find(".errorText").text($('.form_'+cont_id).attr("texto-obligatorio"));
                //console.log($(this).attr('name'));
            }
        }
    })
            
    if($('.form_'+cont_id+' .obliRadio').length>0){
        var selected = [];
        var names = [];
        $('.form_'+cont_id+' .obliRadio').each(function() {
            var obliCheckInvisible = $(this).closest(".radio").find(".circle");
            if($(this).is(":visible") || obliCheckInvisible.is(":visible")){
                //selected.push($(this).val());
                var seleccionado = $(this).closest(".listChecks").find("input[type='radio']:checked").length;
                if(seleccionado==0 && names.indexOf($(this).attr("name"))==-1){
                    resultado = false;
                    $(this).closest(".form-group").addClass("has-error");
                    labels.push($(this).closest(".form-group").find(".control-label").text()+" "+$('.form_'+cont_id).attr("texto-obligatorio"));
                    $(this).closest(".form-group").find(".errorText").text($('.form_'+cont_id).attr("texto-obligatorio"));
                }
                names.push($(this).attr("name"));
            }
        });
    }
    
    if(resultado){
        $('.form_'+cont_id+' input[type="email"]').each(function(){
            var valorEm = $(this).val();
            if($(this).is(":visible") && ($(this).hasClass(".obli") || valorEm.trim() != "")){
                if($(this).is(":invalid")){
                    resultado = false;
                }
            }
        })
        $('.form_'+cont_id+' input[type="tel"]').each(function(){
            var valorEm = $(this).val();
            if($(this).is(":visible") && ($(this).hasClass(".obli") || valorEm.trim() != "")){
                if ($(this).is(":invalid")){
                    resultado = false;
                }
            }
        })
    }
    if (!resultado){
        if ($('.form_'+cont_id).parents('.modal').length){
            $('.form_'+cont_id).closest('.modal').animate({ scrollTop: 0 }, 400);
        }else if ($('.form_'+cont_id).parents('.to').length){
            $('.form_'+cont_id).closest('.to').animate({ scrollTop: 0 }, 500);
        } else{
            $("html, body").animate({ scrollTop: $('.form_'+cont_id).offset().top-120 }, 400);
        }
    }
    if(labels.length>0){
        //console.log(labels.length);
        //console.log(labels);
        $('.form_'+cont_id+' .alertR').show();
        if ($('.form_'+cont_id).parents('.modal-dialog').length){
            if($('.form_'+cont_id+' .alert').is(":visible")){
                $('.form_'+cont_id).closest('.modal-dialog').animate({ scrollTop: 0 }, 500);
            }
        }else if ($('.form_'+cont_id).parents('.to').length){
            if($('.form_'+cont_id+' .alert').is(":visible")){
                $('.form_'+cont_id).closest('.to').animate({ scrollTop: 0 }, 500);
            }
        } else{
            if($('.form_'+cont_id+' .alertR').is(":visible")){
                $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .alertR').offset().top-150 }, 500);
            }

        }

    }

    return resultado;
}

function sendBloqueFormulario(cont_id){
    $('.form_'+cont_id+' .btn-enviar').hide();
    $('.form_'+cont_id+' .btn-enviando').show();
    //console.log($('.form_'+cont_id+' .btn-enviando').length);
    $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",true);
    var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_'+cont_id).serializeObject();
    var form = document.querySelector('.form_'+cont_id);
    var formData = new FormData(form);
    
    formData.append("_csrf", csrfToken);
    formData.append("lang_id", $('.form_'+cont_id).attr("data-langid"));
    formData.append("cont_id", cont_id);
    formData.append("json", JSON.stringify(json));
    formData.append("page", window.location.href);
    $('.form_'+cont_id+' .msgOK,.form_'+cont_id+' .msgKO').hide();
    setTimeout(function(){
        $.ajax({
            url: ("/ajax/sendformulario").replace("//","/"),
            type: 'POST',
            data: formData,
            dataType: 'json',
            async: false,
            success: function (data) {
                if(data.onsentok.trim()!="" && data.code==1){
                    eval(data.onsentok);
                }
                if(data.onsubmit.trim()!="" && data.code!=1){
                    eval(data.onsubmit);
                }
                if(data.code==1){
                    $('.form_'+cont_id+' .msgOK').show();
                    $('.form_'+cont_id).addClass('sended');
                    //$('.form_'+cont_id+' input[type="text"]').val("");
                    $('.form_'+cont_id+' input').val("");
                    $('.form_'+cont_id+' textarea').val("");
                    $('.form_'+cont_id+' select').val("").change();
                    $('.form_'+cont_id+' checkbox').prop( "checked", false );
                    $('.form_'+cont_id+' radio').prop( "checked", false );
                    // Estos desmarca chocks y radios
                    $('.form_'+cont_id+' input').prop( "checked", false )
                    $('.form_'+cont_id).removeClass( "was-validated" );
                }else{
                    $('.form_'+cont_id+' .msgKO').show();
                }
                $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",false);
                $('.form_'+cont_id+' .btn-enviar').show();
                $('.form_'+cont_id+' .btn-enviando').hide();

                var window_height = $(window).height();
                var window_top_position = $(window).scrollTop();
                if ($('.form_'+cont_id+' .msgOK').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgOK').offset().top < (window_top_position + 150) ){
                    if ($('.form_'+cont_id).parents('.modal').length){
                        $('.form_'+cont_id).closest('.modal').animate({ scrollTop: 0 }, 400);
                    }else{
                        $("html, body").animate({ scrollTop: $('.form_'+cont_id).offset().top-120 }, 400);
                    }
                }
                if ($('.form_'+cont_id+' .msgKO').offset().top > (window_top_position + window_height * 0.75) || $('.form_'+cont_id+' .msgKO').offset().top < (window_top_position + 150) ){
                    if ($('.form_'+cont_id).parents('.modal').length){
                        $('.form_'+cont_id).closest('.modal').animate({ scrollTop: 0 }, 400);
                    }else{
                        $("html, body").animate({ scrollTop: $('.form_'+cont_id+' .msgKO').offset().top-120 }, 400);
                    }
                }
            },
            cache: false,
            contentType: false,
            processData: false
        });
    },500)
    
}

$(document).on("click",".btn-closeAlert",function(){
    $(this).closest(".alert").hide();
})

// Eliminamos posibles mensajes remanentes
$(document).on("click",".btn-close",function(){
    $('.msgOK, .msgKO').hide();
})